import AboutUsSvg from '../media/hexagonIconImage/icons/about_us.svg';
import AnalyticsSvg from '../media/hexagonIconImage/icons/analytics.svg';
import PlayerSvg from '../media/hexagonIconImage/icons/player.svg';

import HardcodedSalesDemoPath from './hardcodedSalesDemoPath';
import {Product} from './product';

export interface PlaybackFeature {
  readonly name: string;
  readonly description?: string;
  readonly iconPath: string;
  readonly product?: Product;
  readonly demoPath?: HardcodedSalesDemoPath;
}

const PlaybackFeaturesData: ReadonlyArray<PlaybackFeature> = [
  {
    name: 'Test - Stream Lab',
    iconPath: AboutUsSvg,
    product: Product.StreamLab,
    demoPath: HardcodedSalesDemoPath.StreamLab
  },
  {
    name: 'Deploy - Player',
    iconPath: PlayerSvg,
    product: Product.Player
  },
  {
    name: 'Optimize & Debug - Analytics',
    iconPath: AnalyticsSvg,
    product: Product.CloudAnalytics
  }
];

export default PlaybackFeaturesData;
